import { render, staticRenderFns } from "./AppSelect.vue?vue&type=template&id=5ccb51d5"
import script from "./AppSelect.vue?vue&type=script&lang=ts"
export * from "./AppSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports